import { render, staticRenderFns } from "./RewardPeriodExport.vue?vue&type=template&id=4fc9b400"
import script from "./reward-period-export.ts?vue&type=script&lang=ts&external"
export * from "./reward-period-export.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports